import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-montserrat\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/custom.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentManager"] */ "/app/src/components/compliance/ConsentManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/performance/PerformanceOptimizer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollRestoration"] */ "/app/src/components/ScrollRestoration.tsx");
